const stage = process.env.REACT_APP_STAGE;

// stage 发布环境
export const isAlpha = stage === 'alpha';
export const isRelease = stage === 'release';

// NODE_ENV
export const isDevelopment = process.env.NODE_ENV === 'development';
export const isProduction = process.env.NODE_ENV === 'production';

export const isUseConsole = process.env.REACT_APP_USE_CONSOLE === 'true';
